// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--rR9tD","mallModule":"mallModule--WbwYf","markerAnimationScale":"markerAnimationScale--PZaKA"};